<div class="modal" [class.active]="showModal">
    <div class="modal-content">
        <div class="modal-header">
            <h3>{{ isEditMode ? 'Edit Drug Entry' : 'Add New Drug Entry' }}</h3>
            <button class="modal-close" (click)="closeModal()">
                <i class="fas fa-times"></i>
            </button>
        </div>
        <div class="modal-body">
            <div class="modal-body">
                <!-- <div class="row" *ngIf="filters.type && filters.type === 'sNDA'">
                <div class="form-group col-6">
                    <label for="drug-name">Enter the Molecule </label>
                    <input type="text" id="drug-name" name="drugName" [(ngModel)]="brandname" class="form-control" (keydown.enter)="searchMolecule()" autofocus>
                </div>
                <button type="button" class="btn btn-primary col-2" (click)="searchMolecule()">Search</button>
                <button type="button" class="btn btn-primary col-2" (click)="clearData()">Clear</button>

            </div>
            <div class="row" *ngIf="filters.type && filters.type === 'sNDA'">
                <div class="form-group col-6">
                    <p-dropdown [options]="submolecules" [(ngModel)]="selectedSubMolecule" autoWidth="false"
                    [style]="{'width':'90%','font-size':'12px'}" optionLabel="name" placeholder="Select NDA"
                    (onChange)="getData()" *ngIf="subMolecule">
                  </p-dropdown>
                 

                </div>
            </div> -->
                <!-- Debug information -->
                <!-- <div *ngIf="getSelectedCategoriesForDisplay().length > 0" class="debug-info" style="background-color: #f0f9ff; border: 1px solid #0ea5e9; border-radius: 0.375rem; padding: 1rem; margin-bottom: 1rem;">
                <h4 style="margin: 0 0 0.5rem 0; color: #0c4a6e; font-size: 0.875rem;">Selected Categories:</h4>
                <p style="margin: 0; color: #0c4a6e; font-size: 0.75rem;">{{ getSelectedCategoriesForDisplay().join(', ') }}</p>
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="testIntersectionLogic()" style="margin-top: 0.5rem;">
                    Test Intersection Logic
                </button>
            </div> -->

                <form id="drug-form" [formGroup]="drugForm" (ngSubmit)="onSubmit()">
                    <div class="form-grid">
                        <div class="form-group">
                            <label for="drug-name">Drug Name </label>
                            <input type="text" id="drug-name" name="drugName" formControlName="drugName" required>
                        </div>

                        <div class="form-group">
                            <label for="company-name">Company Name</label>
                            <!-- <ckeditor [editor]="Editor" formControlName="companyName" >
                        </ckeditor> -->
                            <input type="text" id="company-name" name="companyName" formControlName="companyName"
                                required>
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="active-ingredient">Active Ingredient </label>
                        <ckeditor [editor]="Editor" formControlName="activeIngredient">
                        </ckeditor>
                        <!-- <input type="text" id="active-ingredient" name="activeIngredient" formControlName="activeIngredient" required > -->
                    </div>
                    <div class="form-group">
                        <label for="route-administration">Route of Administration</label>
                        <ckeditor [editor]="Editor" formControlName="routeOfAdministration">
                        </ckeditor>
                        <!-- <input type="text" id="route-administration" name="routeOfAdministration" formControlName="routeOfAdministration" > -->

                    </div>
                    <div class="form-group">
                        <label for="dosage-form">Dosage Form</label>
                        <!-- <input type="text" id="dosage-form" name="dosageForm" formControlName="dosageForm" > -->
                        <ckeditor [editor]="Editor" formControlName="dosageForm">
                        </ckeditor>

                    </div>
                    <div class="form-group">
                        <label for="strength">Strength</label>
                        <ckeditor [editor]="Editor" formControlName="strength">
                        </ckeditor>
                        <!-- <input type="text" id="strength" name="strength" formControlName="strength"> -->
                    </div>
                    <div class="form-group">
                        <label for="dosing-regimen">Dosing Regimen</label>
                        <ckeditor [editor]="Editor" formControlName="dosingRegimen">
                        </ckeditor>
                        <!-- <input type="text" id="dosing-regimen" name="dosingRegimen" formControlName="dosingRegimen" > -->
                    </div>
                    <!-- <div class="form-group">
                    <label for="indication">PDUFA Comment</label>
                    <ckeditor [editor]="Editor" formControlName="padufa">
                  </ckeditor>
                </div> -->
                    <div class="form-group">
                        <label for="indication">Indication</label>
                        <ckeditor [editor]="Editor" formControlName="indication">
                        </ckeditor>
                    </div>
                    <!-- sNDA: Previous (old*) fields -->
                    <div *ngIf="filters?.type === 'sNDA'">
                        <div class="form-group">
                            <label for="old-route">Old Route of Administration</label>
                            <ckeditor [editor]="Editor" formControlName="oldrouteOfAdministration">
                            </ckeditor>
                        </div>
                        <div class="form-group">
                            <label for="old-dosage-form">Old Dosage Form</label>
                            <ckeditor [editor]="Editor" formControlName="olddosageForm">
                            </ckeditor>
                        </div>
                        <div class="form-group">
                            <label for="old-strength">Old Strength</label>
                            <ckeditor [editor]="Editor" formControlName="oldstrength">
                            </ckeditor>
                        </div>
                        <div class="form-group">
                            <label for="old-dosing-regimen">Old Dosing Regimen</label>
                            <ckeditor [editor]="Editor" formControlName="olddosingRegimen">
                            </ckeditor>
                        </div>
                        <div class="form-group">
                            <label for="old-indication">Old Indication</label>
                            <ckeditor [editor]="Editor" formControlName="oldindication">
                            </ckeditor>
                        </div>
                    </div>
                    <div class="form-grid">
                        <div class="form-group">
                            <label for="pdufa-date">PDUFA Date</label>
                            <input type="date" id="pdufa-date" name="pdufaDate" formControlName="pdufaDate">
                        </div>
                        <div class="form-group">
                            <label for="filling-date">Filling Date</label>
                            <input type="date" id="filling-date" name="fillingDate" formControlName="fillingDate">
                        </div>
                        <div class="form-group">
                            <label for="acceptance-date">Acceptance Date</label>
                            <input type="date" id="acceptance-date" name="acceptanceDate"
                                formControlName="acceptanceDate">
                        </div>
                        <div class="form-group">
                            <label for="quarter-selection">Quarter Selection</label>
                            <select id="quarter-selection" name="quarterSelection" formControlName="quarterSelection">
                                <option value="">Select Quarter</option>
                                <option value="Quarter 1">Quarter 1</option>
                                <option value="Quarter 2">Quarter 2</option>
                                <option value="Quarter 3">Quarter 3</option>
                                <option value="Quarter 4">Quarter 4</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="quarter-selection-date">Quarter Selection Year</label>
                            <select id="quarter-selection" name="quarterSelectionYear"
                                formControlName="quarterSelectionYear">
                                <option value="">Select Year</option>
                                <option value={{year}} *ngFor="let year of years">{{ year }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="peak-sales">Peak Sales (USD)</label>
                            <input type="text" id="peak-sales" name="peakSales" step="1" formControlName="peakSales">
                        </div>
                        <div class="form-group">
                            <label for="quarter-selection">PDUFA Status</label>
                            <select id="quarter-selection" name="statusSelection" formControlName="statusSelection">
                                <option value="">Select Status</option>
                                <option value="Approved">Approved</option>
                                <option value="Under Review">Under Review
                                </option>
                                <option value="CRL Issued">CRL Issued</option>
                                <option value="PDUFA Extension">PDUFA Extension</option>
                            </select>
                        </div>

                        <!-- <div class="form-group full-width" id="nda-mapping-group" style="display: none;">
                        <label for="linked-nda">Link to Existing NDA *</label>
                        <select id="linked-nda" name="linkedNda">
                            <option value="">Select an existing NDA...</option>
                        </select>
                    </div> -->

                    </div>
                    <div class="form-group">
                        <label for="comments">Comments</label>
                        <ckeditor [editor]="Editor" formControlName="comments">
                        </ckeditor>
                    </div>

                    <!-- FDA Designations -->
                    <div class="form-section">
                        <h4>FDA Designations</h4>
                        <div class="checkbox-grid">
                            <label *ngFor="let designation of designationTags" class="checkbox-item">
                                <input type="checkbox" [value]="designation"
                                    [checked]="isDesignationSelected(designation)"
                                    (change)="onDesignationChange(designation, $event)">
                                <span class="checkmark"></span>
                                {{designation}}
                            </label>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" id="cancel-btn"
                            (click)="closeModal()">Cancel</button>
                        <button type="submit" class="btn btn-primary">Save Entry</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>